export default {
  filters: {
    $_currencyFilter_usd(value) {
      if (value != null) {
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'decimal',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
        return '$' + formatter.format(value)
      }
      return '-'
    },
    $_currencyFilter_usdNoCents(value) {
      if (value != null) {
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'decimal',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })
        return '$' + formatter.format(value)
      }
      return '-'
    }
  },

  methods: {
    $_currencyMethod_usd(value) {
      if (value != null) {
        if (parseFloat(value) >= 0) {
          let v = value.toLocaleString()
          if (v.indexOf('.') === -1) v = v + '.00'
          let len = v.length
          let loc = v.indexOf('.')
          if (len - loc > 2) v = v.substr(0, loc + 3)
          return '$' + v
        }
      }
      return '-'
    },
    $_currencyMethod_usdNoCents(value) {
      if (value != null) {
        if (parseInt(value) >= 0) {
          var nf = new Intl.NumberFormat()
          return '$' + nf.format(parseInt(value))
        }
      }
      return '-'
    }
  }
}
